export default {"src":"/_next/static/media/newsletter.f912aae2.svg","height":72,"width":72};